import React from 'react'
import styled from 'styled-components'
import numeral from 'numeral'

const PriceContainer = styled.div`
  display: flex;
  flex-direction: column;
`

const PriceText = styled.div`
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  margin-bottom: 4px;
`

const PriceNumber = styled.div`
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: -0.01em;
`

const Price = ({ isGrid, startingPrice, startingPriceBedroom }) => {
  if (isGrid) {
    const bedroomType =
      startingPriceBedroom === 0
        ? 'Studio'
        : startingPriceBedroom === 1
        ? '1 bedroom'
        : `${startingPriceBedroom} bedrooms`

    return (
      <PriceContainer>
        <PriceText>{`${bedroomType} starting at`}</PriceText>
        <PriceNumber>{numeral(startingPrice).format('$0,0')}</PriceNumber>
      </PriceContainer>
    )
  }

  return <PriceNumber>{numeral(startingPrice).format('$0,0')}</PriceNumber>
}

export default Price
